import React, { memo, useEffect, useRef } from 'react';
import HeadshotImg from "../img/headshot.jpg";

function Headshot() {
    return (
        <section id="headshot">
            <img src={HeadshotImg} alt="Me (a white man with brown hair in a blue t-shirt) with trees in the background"></img>
        </section>
    );
}

export default memo(Headshot);